import React from "react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import { NextSeo } from "next-seo";
import ProductsHeadingSection from "@/components/products/heading-section";
import BrandsSection from "@/components/products/brands-section";
import ProductsSection from "@/components/products/products-section";
import PackagesSection from "@/components/products/packages-section";
import PrivateLabelSection from "@/components/products/private-label-section";

const translationNamespaces = ["common", "nav", "products"];

export const getStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, translationNamespaces)),
    },
  };
};

const Products = () => {
  const { t } = useTranslation();
  return (
    <div>
      <NextSeo
        title={"Products"}
        description={
          "AlHayat Foodstuff specializes in frozen vegetables. Explore our products and find the perfect fit for your market."
        }
        canonical={"https://alhayatfoodstuff.com/products"}
        openGraph={{
          title: "Products",
          description:
            "AlHayat Foodstuff specializes in frozen vegetables. Explore our products and find the perfect fit for your market.",
        }}
      />
      <ProductsHeadingSection />
      <BrandsSection />
      <ProductsSection />
      <PackagesSection />
      <PrivateLabelSection />
    </div>
  );
};

export default Products;
